import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './FilterUniversal.css';
import ScrollContainer from 'react-indiana-drag-scroll'
import 'react-indiana-drag-scroll/dist/style.css'

function FilterUniversal({ filterName, filterIcon, id_filter, list, selected, clickHandler, show_all, show_count }) {

    /*
    ФОРМАТ LIST:
            id - ИД проекта
            name - Название элемента
            count - Кол-во элементов в проекте   
            color - Цвет   
    ПАРАМЕТРЫ:
            selected - ИД выбранного проекта
            id_filter- ИД фильтра. Для случаев, когда на странице несколько фильтров. Пример в задачах несколько вкладок с фильтрами
            show_all - Показывать все элементы, даже если 0
            show_count - Показывать счетчик количества элементов
            filterName: название фильтра. Если не заполнено, то не отображаем
            filterIcon: иконка фильта
    */

    //Событие изменения фильтра
    function clickHandler_(id) {
        clickHandler(id, id_filter);
    }

    return (
        <>
            {list.length > 0 && (
                <>
                    {
                        filterName !== undefined && (<div className="filter_u_name"><FontAwesomeIcon icon={filterIcon} className="mr-5 opacity-50" /> {filterName}:</div>)
                    }
                    {

                        <div className="filter_u_block">
                            <ScrollContainer className="scroll-container">
                                {
                                    list.filter(a => a.count > 0 || show_all === true).map((model) => (
                                        <div
                                            key={Math.random()}
                                            id={model.id}
                                            onClick={() => clickHandler_(model.id)}
                                            className={model.id === selected ? ("filter_u_item active") : ("filter_u_item")}
                                            style={{ backgroundColor: model.color == null ? "RGB(144,147,152)" : model.color, }}>
                                            {model.name} {show_count && (<>{model.count != null && (<>({model.count})</>)}</>)}
                                        </div>
                                    ))
                                }
                            </ScrollContainer>
                        </div>
                    }
                </ >
            )}
        </>
    )
}

export default FilterUniversal;